export default __webpack_public_path__ + "static/media/shard-identity.4d742cbe.glb";